import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiX, FiExternalLink } from 'react-icons/fi';
import JobDetailContent from './JobDetailContent';
import { Link } from 'react-router-dom';

const JobDrawer = ({ job, isOpen, onClose }) => {
  // Use a more stable scroll lock strategy
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('drawer-open');
    } else {
      document.body.classList.remove('drawer-open');
    }
    return () => {
      document.body.classList.remove('drawer-open');
    };
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[3000] flex justify-end">
          {/* Overlay - Fixed to inset-0 to cover everything */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={onClose}
            className="absolute inset-0 bg-stone-900/40 backdrop-blur-sm"
          />

          {/* Drawer Container - Uses fixed width and height to prevent parent reflows */}
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ 
              type: 'spring', 
              damping: 30, 
              stiffness: 300,
              mass: 0.8
            }}
            className="relative h-full w-full max-w-2xl bg-white shadow-2xl overflow-hidden flex flex-col"
          >
            {/* Drawer Header Toolbar */}
            <div className="shrink-0 z-20 bg-white/80 backdrop-blur-md border-b border-stone-100 p-4 flex items-center justify-between">
              <Link 
                to={`/jobs/${job?.id}`}
                className="inline-flex items-center gap-2 text-stone-500 hover:text-emerald-600 text-xs font-bold uppercase tracking-widest transition-colors"
              >
                <SafeIcon icon={FiExternalLink} /> Full Page View
              </Link>
              <button 
                onClick={onClose}
                className="p-2 hover:bg-stone-100 rounded-full text-stone-400 hover:text-stone-900 transition-all"
              >
                <SafeIcon icon={FiX} className="text-2xl" />
              </button>
            </div>

            {/* Content Scroll Area */}
            <div className="flex-1 overflow-y-auto overflow-x-hidden custom-scrollbar p-6 md:p-10">
              {job && <JobDetailContent job={job} />}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default JobDrawer;